"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MethodContext = /** @class */ (function () {
    function MethodContext(target, key, queryContext, weblabContext) {
        this.target = target;
        this.key = key;
        this.queryContext = queryContext;
        this.weblabContext = weblabContext;
    }
    MethodContext.prototype.executeTarget = function () {
        return this.target.getValue(this.key, this.queryContext, this.weblabContext);
    };
    return MethodContext;
}());
exports.default = MethodContext;
